import Icon from './components/Icon';

export default Icon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons-vue@2.0.0@@ant-design/icons-vue/es/index.js
// module id = null
// module chunks = 